// Main Layout Component
//
// The WorklistProvider sits here so the sidebar badges, the header indicator
// and the Today screen all read ONE feed of what is waiting — the same numbers
// everywhere, for one request.

import React, { useState } from 'react';
import Header from './Header.jsx';
import Sidebar from './Sidebar.jsx';
import { WorklistProvider } from '../../hooks/useWorklist';

const MainLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <WorklistProvider>
      <div className="flex h-screen bg-slate-100">
        {/* Mobile backdrop */}
        {sidebarOpen && (
          <div
            className="lg:hidden fixed inset-0 z-40 bg-slate-900/60 backdrop-blur-sm"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

        <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
          <Header onMenuToggle={() => setSidebarOpen((v) => !v)} />
          <main className="flex-1 overflow-y-auto">
            <div className="max-w-screen-xl mx-auto px-4 py-5 sm:px-6 sm:py-8">
              {children}
            </div>
          </main>
        </div>
      </div>
    </WorklistProvider>
  );
};

export default MainLayout;
